export function isTranslationV2Enabled() {
    return process.env.ENABLE_TRANSLATION_V2 === 'true';
}
